import type { ComponentType } from 'react';

import type { MoreActionsMenuProps } from 'js/single_work/loswp/MoreActionsMenu';

export function loadMoreActionsMenu(): Promise<
  ComponentType<MoreActionsMenuProps>
> {
  return import('js/single_work/loswp/MoreActionsMenu').then(
    (module) => module.MoreActionsMenu,
  );
}

export default loadMoreActionsMenu;
